import 'es6-map/implement'
import 'es6-set/implement'
import React from 'react'
import 'react-app-polyfill/ie11'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import 'string.prototype.startswith'
import App from './App'
import { AuthProvider } from './authContext'
import * as billy from './billy'
import { loadResources, settings } from './resources'

const start = async () => {
  const root = document.getElementById('customer-mytui-web-root')

  if (!root) return

  await loadResources(false)

  if (window.location.href.indexOf('/ati/') === -1 && window.location.href.indexOf('/servicerequest/') === -1) {
    billy.addScript('/widgets/assets/javascripts/top-navigation.js')
    billy.addScript('/widgets/assets/javascripts/footer.js')
  }

  ReactDOM.render(
    <AuthProvider>
      <Router>
        <App />
      </Router>
    </AuthProvider>,
    root,
  )
}

start()
